import { countContentByType, findContentIndexesByPk } from '../../lib/arrayOperations'
import CreateTrainingResult from '../../GraphQL/CreateTrainingResult'
import UpdateTrainingResult from '../../GraphQL/UpdateTrainingResult'
import { updateTrainingResult } from '../../redux/app/actions'
import { setUpdatingTrainingResult } from '../../redux/trainingProgram/actions'

function complete(content, hsk, playlist, result, user, cb) {
    const key = content.type === 'VIDEO' ? 'videosCompleted' : 'quizzesCompleted'

    //console.log("result: ", result)

    if (result && result[key] && result[key].some(pk => pk === content.pk)) {
        if (typeof cb === 'function') cb()
        return
    }

    const now = new Date().getTime()
    let newResult
        = result
        ?   {
                [key]: [ ...result[key], content.pk ],
                updatedAt: now,
                sk: result.sk
            }
        :   {
                certificateType: playlist.certificateType,
                createdAt: now,
                pk: user.pk,
                d1: hsk,
                d2: user.d2,
                firstName: user.firstName,
                lastName: user.lastName,
                quizzesCompleted: content.type === 'QUIZ' ? [content.pk] : [],
                sk: `TRAINING_RESULT#${playlist.pk}#IN_PROGRESS`,
                title: playlist.meta.title,
                updatedAt: now,
                userType: playlist.userType,
                version: 1,
                videosCompleted: content.type === 'VIDEO' ? [content.pk] : []
            }

    const quizzesCompleted = newResult.quizzesCompleted || result.quizzesCompleted
    const videosCompleted = newResult.videosCompleted || result.videosCompleted
    const allQuizzesComplete = quizzesCompleted ? quizzesCompleted.length === countContentByType(playlist, 'QUIZ') : false
    const allVideosComplete = videosCompleted ? videosCompleted.length === countContentByType(playlist, 'VIDEO') : false

    if (allQuizzesComplete && allVideosComplete) {
        newResult.completedAt = now
        newResult.sk = `TRAINING_RESULT#${playlist.pk}#COMPLETE`
    }

    setUpdatingTrainingResult(true)
    
    if (result) {
        UpdateTrainingResult({
            expectedVersion: result.version,
            input: newResult,
            pk: result.pk,
            sk: result.sk
        }, response => {
            updateTrainingResult(response.data.updateTrainingResult)
            setUpdatingTrainingResult(false)
            if (typeof cb === 'function') cb()
        })
    } else {
        CreateTrainingResult({ input: newResult }, response => {
            console.log("response: ", response.data)
            updateTrainingResult(response.data.createTrainingResult)
            setUpdatingTrainingResult(false)
            if (typeof cb === 'function') cb()
        })
    }
}

function findFirstIncomplete(index, playlist, trainingResult) {
    if (!trainingResult) return playlist.sections[0].content[0]

    function isChildContentComplete(section) {
        return section.content.every(content => isComplete(content))
    }

    function isComplete(content) {
        if (content.type === 'VIDEO' && trainingResult.videosCompleted) {
            return trainingResult.videosCompleted.some(pk => pk === content.pk)
        } else if (content.type === 'QUIZ' && trainingResult.quizzesCompleted) {
            return trainingResult.quizzesCompleted.some(pk => pk === content.pk)
        } else if (content.type === 'CONNECTION' && !content.hidden) {
            const contentIndexes = findContentIndexesByPk(playlist, content.to)
            if (contentIndexes.sectionIndex === 0) return true
            return isChildContentComplete(playlist.sections[contentIndexes.sectionIndex])
        } else {
            return true
        }
    }

    const found = playlist.sections[index].content.find(content => !isComplete(content))

    if (found && found.type === 'CONNECTION') {
        const contentIndexes = findContentIndexesByPk(playlist, found.to)
        return findFirstIncomplete(contentIndexes.sectionIndex, playlist, trainingResult)
    }

    return found
}

export {
    complete,
    findFirstIncomplete
}